<template>
  <div class="otp-inputs">
    <input
      v-for="(d, i) in length"
      :key="i"
      ref="boxes"
      class="otp-box"
      type="tel"
      inputmode="numeric"
      maxlength="1"
      :value="digits[i]"
      @input="onInput(i, $event)"
      @keydown="onKeydown(i, $event)"
      @paste="onPaste(i, $event)"
    >
  </div>
</template>

<script>
export default {
  name: 'otp-code-input',
  props: {
    length: { type: Number, default: 6 },
    value: { type: String, default: '' },
    autofocus: { type: Boolean, default: false },
  },
  data() {
    return {
      digits: Array.from({ length: this.length }, (_, i) => this.value[i] || ''),
    }
  },
  watch: {
    value(newVal) {
      const v = String(newVal || '')
      for (let i = 0; i < this.length; i++) this.$set(this.digits, i, v[i] || '')
    },
  },
  mounted() {
    if (this.autofocus) this.focusFirst()
  },
  methods: {
    focusFirst() {
      const el = this.$refs.boxes && this.$refs.boxes[0]
      el && el.focus && el.focus()
    },
    emitValue() {
      const code = this.digits.join('')
      this.$emit('input', code)
      if (code.length === this.length) this.$emit('complete', code)
    },
    onInput(i, e) {
      const str = String(e.target.value || '').replace(/\D/g, '')
      if (!str) {
        this.$set(this.digits, i, '')
        this.emitValue()

        return
      }
      const chars = str.split('')
      this.$set(this.digits, i, chars.shift())
      let j = i + 1
      while (chars.length && j < this.length) {
        this.$set(this.digits, j, chars.shift())
        j++
      }
      this.emitValue()
      const nextIdx = Math.min(j, this.length - 1)
      const boxes = this.$refs.boxes || []
      boxes[nextIdx] && boxes[nextIdx].focus && boxes[nextIdx].focus()
    },
    onKeydown(i, e) {
      const boxes = this.$refs.boxes || []
      if (e.key === 'Backspace') {
        if (this.digits[i]) {
          this.$set(this.digits, i, '')
          this.emitValue()

          return
        }
        if (i > 0) {
          e.preventDefault()
          this.$set(this.digits, i - 1, '')
          boxes[i - 1] && boxes[i - 1].focus && boxes[i - 1].focus()
          this.emitValue()
        }
      } else if (e.key === 'ArrowLeft' && i > 0) {
        boxes[i - 1] && boxes[i - 1].focus && boxes[i - 1].focus()
      } else if (e.key === 'ArrowRight' && i < this.length - 1) {
        boxes[i + 1] && boxes[i + 1].focus && boxes[i + 1].focus()
      }
    },
    onPaste(i, e) {
      e.preventDefault()
      const clip = (e.clipboardData || window.clipboardData).getData('text') || ''
      const digits = clip.replace(/\D/g, '')
      if (!digits) return
      if (digits.length >= this.length) {
        for (let k = 0; k < this.length; k++) this.$set(this.digits, k, digits[k] || '')
        this.emitValue()
        const boxes = this.$refs.boxes || []
        boxes[this.length - 1] && boxes[this.length - 1].focus && boxes[this.length - 1].focus()

        return
      }
      let idx = i
      for (const ch of digits) {
        if (idx > this.length - 1) break
        this.$set(this.digits, idx++, ch)
      }
      this.emitValue()
      const boxes = this.$refs.boxes || []
      const nextIdx = Math.min(idx, this.length - 1)
      boxes[nextIdx] && boxes[nextIdx].focus && boxes[nextIdx].focus()
    },
  },
}
</script>

<style scoped>
.otp-inputs {
  display: flex;
  gap: 12px;
  margin: 12px 0;
}
.otp-box {
  width: 56px;
  height: 56px;
  text-align: center;
  font-size: 20px;
  border-radius: 8px;
  border: 1px solid var(--Grey-30, #d9d9d9);
}
.otp-box:focus {
  outline: none;
  border-radius: 8px;
  border: 1px solid var(--Grey-10, #666);
}
</style>
